<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="pa-0">
        <v-card-title class="ma-0 pa-0">
          <v-row no-gutters class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="mx-2 my-2 primary--text">
                {{ $t("settings.area.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                class="mx-2"
                :placeholder="$t('landlord.name')"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('AREA')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("settings.area.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          :header-props="{ align: $vuetify.rtl ? 'right' : 'left' }"
          id="areaTable"
          :hide-default-footer="footer"
          :headers="headers"
          :items="areaLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          class="mt-2 pa-0 datatable"
          :server-items-length="totalArea"
          item-class="headerClass"
        >
          <!-- for subArea expand table  -->
          <!-- :expanded.sync="expanded"
          show-expand
          single-expand
          item-key="_id" countryName-->
          <!-- <template #item.countryCode="{ item }">
            <span>{{ getCountryNameFromCode(item.countryCode) }}</span>
          </template> -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="py-0 my-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  areaLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" class="mx-2" @click="editArea(item)"
                >mdi-pencil</v-icon
              >
            </v-row>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-switch
                v-if="!footer"
                v-model="item.isActive"
                @change="toggleAreaStatus(item)"
              >
              </v-switch>
              <span v-else>{{ item.isActive ? "true" : "false" }}</span>
            </v-row>
          </template>
          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-1 custom-data-table">
              <v-card class="mx-2">
                <v-data-table
                  :footer-props="{
                    'items-per-page-options': [50, 100, 150, 200, -1]
                  }"
                  class="datatable"
                  mobile-breakpoint="0"
                  :headers="subHeaders"
                  :items="item.subAreas"
                >
                  <template v-slot:[`item._id`]="{ item }">
                    <p class="ma-0">
                      {{ item.index + 1 }}
                    </p>
                  </template>
                </v-data-table>
              </v-card>
            </td>
          </template> -->
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { toggleAreaStatus } from "../methods/area/toggle_area_status";
import { getCountryNameFromCode } from "../methods/area/country_list";
import { toggleGovernateStatus } from "../methods/governate/toggle_governate_status";
export default {
  data() {
    return {
      expanded: [],
      footer: false,
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      areaLists: [],
      totalArea: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          value: "nameEn",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          value: "nameAr",
          sortable: false,
          width: 10
        },
        // {
        //   text: this.$t("settings.area.countryName"),
        //   value: "countryCode",
        //   sortable: false,
        //   width: 10
        // },
        {
          text: this.$t("settings.area.isActive"),
          value: "isActive",
          sortable: false,
          width: 10
        },
        // {
        //   text: "",
        //   value: "data-table-expand",
        //   align: "center"
        // },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          width: 20
        }
      ].map(header => {
        header.class = "headerClass";
        header.align = "center";
        return header;
      });
    }
    // subHeaders() {
    //   return [
    //     {
    //       text: "#",
    //       align: "left",
    //       value: "_id",
    //       sortable: false,
    //       width: 10
    //     },
    //     {
    //       text: this.$t("settings.area.nameEn"),
    //       align: "left",
    //       value: "nameEn",
    //       sortable: false,
    //       width: 100
    //     },
    //     {
    //       text: this.$t("settings.area.nameAr"),
    //       align: "left",
    //       sortable: false,
    //       value: "nameAr",
    //       width: 100
    //     }
    //   ];
    // }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getAreas.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalArea,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getAreas.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalArea,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getAreas() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/governates/governate_query.graphql"),
        variables: {
          input: {
            limit: this.totalArea,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.areaLists = this.$format.cloneVariable(
            data.getGovernates.governates
          );
          console.log(data.getGovernates.governates);
          this.loading = loading;
          this.totalArea = data.getGovernates.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "area") {
        const input = data.item._id;
        toggleAreaStatus(input).then(data => {
          if (data.data.toggleAreaStatus) {
            this.$apollo.queries.getAreas.refetch({
              limit:
                this.options.itemsPerPage !== -1
                  ? this.options.itemsPerPage
                  : this.totalArea,
              skip:
                this.options.page * this.options.itemsPerPage -
                this.options.itemsPerPage
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });
    this.$root.$on("areaTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchArea", () => {
      this.loading = true;
      this.$apollo.queries.getAreas.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalArea,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: ""
        }
      });
      this.loading = false;
    });
    this.$root.$on("searchArea", data => {
      this.search = data;
    });
    this.$root.$on("exportArea", () => {
      this.exportData();
    });
    this.$root.$on("toggleItems", data => {
      if (data.module === "area") {
        toggleGovernateStatus({
          id: data.item._id,
          status: data.item.isActive
        }).then(({ data }) => {
          if (data.toggleGovernateStatus) {
            this.$store.commit("TOGGLE_BTN_LOADING", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: "Governate Status Changed Successfully",
              color: "green"
            });
            this.$root.$emit("refetchArea");
          }
        });
      }
    });
  },
  methods: {
    getCountryNameFromCode: getCountryNameFromCode,
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getAreas
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(response => {
          this.options.itemsPerPage = response.data.getGovernates.totalCount;
          this.areaLists = response.data.getGovernates.governates;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel("areaTable", "area");
          }, 1000);
        });
    },
    toggleAreaStatus(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "area"
      });
      this.$root.$emit("refetchArea");
    },
    editArea(item) {
      this.$store.commit("IS_EDIT_AREA", true);
      this.$store.commit("EDIT_AREA", item);
      this.$store.commit("APP_SETTINGS_FORMNAME", "AREA");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("areaTable");
    this.$root.$off("refetchArea");
    this.$root.$off("exportArea");
    this.$root.$off("searchArea");
    this.$root.$off("toggleItems");
  }
};
</script>
<style>
.v-input--switch .v-input--selection-controls__input {
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
<style scoped>
.custom-data-table {
  background: #ffffff !important;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2) !important;
}
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
